import { Injectable, Injector } from '@angular/core';
import { Map, proj, interaction, geom, format } from 'openlayers';
import { DiagnosedItem } from '../../dataModels/diagnosed-item';
import { Subject } from 'rxjs';

declare var ol: any;
declare var google: any;
@Injectable()
export class MapUtilitiesServices extends DiagnosedItem {

    //#region Private Members
    private map: any;

    constructor(protected injector: Injector) {
        super(injector);
    }



    //#region public Methods
   

    public GetMapAddress(lat: number, lng: number): any {
        let geocoder = new google.maps.Geocoder();
        let latlng = new google.maps.LatLng(lat, lng);
        let request = {
            latLng: latlng
        };
        return new Promise((resolve, reject) => {
            geocoder.geocode(request, (results, status) => {
                if (status == google.maps.GeocoderStatus.OK) {
                    if (results[0] != null) {
                        resolve(results[0].formatted_address);
                    }
                } else resolve(null);

            });
        });
    }

    
    //#endregion
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/maps/map-Utilities.services.ts